import React from "react";
import Swal from "sweetalert2";
import { UserIcon } from "../../../../components/IconsSVG";
import { Link } from "react-router-dom";
import AdminDropdown from "../../../../partials/content/CustomDropdowns/AdminDropdown";
import Datatable from "../../../../partials/datatable/Datatable";
import {
	StyledTableCell,
	StyledTableRow
} from "../../../../partials/datatable/styles";
import { MutantApiService } from "../../../../services/MutantApiService";
import store from "../../../../store/store";
import Loading from "../../../home/components/Loading";
import { format } from "date-fns";
import { Button } from "@material-ui/core";
import "./voice-models-listing.scss";
import { min } from "lodash";

const initialState = {
	voiceModels: [],
	reload: false,
	loading: true
};

export default class VoiceModelsListing extends React.Component {
	constructor(props) {
		super(props);
		const { auth } = store.getState();

		this.api = new MutantApiService();

		this.state = {
			...initialState,
			userLogged: auth.user
		};

		this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
		this.formatRow = this.formatRow.bind(this);
		this.setVoiceModels = this.setVoiceModels.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	handleConfirmChangeStatus = async function(obj) {
		try {
			await this.setState({ loading: true });

			await this.api.makeHttpRequest({
				method: "PUT",
				url: `/models/${obj.id}`
			});

			await this.setState({ loading: false });

			await Swal.fire({
				title: "Sucesso!",
				text: "Status alterado com sucesso.",
				icon: "success",
				cancelButtonText: "Sair"
			});
		} catch (e) {
			await this.setState({ loading: false });
			await Swal.fire("Erro!", "Erro ao alterar status.", "error");
		} finally {
			await this.setState({ reload: !this.state.reload });
		}
	};

	setVoiceModels = voiceModels => {
		this.setState({ voiceModels });
	};

	handleConfirmDelete = async id => {
		try {
			const reqBase = { method: "DELETE", url: `/models/${id}/` };

			await this.api.makeHttpRequest(reqBase);
			await this.setState({ reload: !this.state.reload });
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao reverter as alterações, tente mais tarde",
				"error"
			);
		}
	};

	formatRow = voiceModel => {
		return (
			<StyledTableRow hover tabIndex={-1} key={voiceModel.id}>
				<StyledTableCell scope="row" align="left" width="50%">
					<Link
						to={`/dashboard/models/${voiceModel.id}/edit`}
						className="model-button"
						style={{ 
							paddingRight: "20px",
						}}
					>
						{!!voiceModel.name && `${voiceModel.name}`}
					</Link>
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="10%">
					{!!voiceModel.status && !!voiceModel.status ? "Ativo" : "Inativo"}
				</StyledTableCell>
			<StyledTableCell scope="row" align="left" width="10%">
					{voiceModel.provider} 
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="20%">
					{!!voiceModel.updatedAt &&
						format(new Date(voiceModel.updatedAt), "dd/MM/yyyy hh:mm")}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="20%">
					{!!voiceModel.createdAt &&
						format(new Date(voiceModel.createdAt), "dd/MM/yyyy hh:mm")}
				</StyledTableCell>
			</StyledTableRow>
		);
	};

	render() {
		window.setPageTitle("Listagem de projetos");

		const headRows = [
			{ label: "Nome", align: "left" },
			{ label: "STATUS", align: "left" },
			{ label: "PROVEDOR", align: "left" },
			{ label: "DATA DE ATUALIZAÇÃO", align: "left" },
			{ label: "DATA DE CRIAÇÃO", align: "left" }
		];

		return (
			<>
				<Loading isLoading={this.state.loading} />
				<Datatable
					title="Modelos de Voz"
					icon={UserIcon}
					endpoint="models"
					className="h-100"
					headRows={headRows}
					formatRow={this.formatRow}
					rows={this.state.voiceModels}
					clietsRows={this.state.clients}
					setRows={this.setVoiceModels}
					reload={this.state.reload}
					placeholderSearch="Filtre por Nome"
					mobile={AdminDropdown}
					width={this.props.width}
					hiddenReload
					voiceModels
					buttons={[
						{
							label: "Adicionar",
							onClick: null,
							icone: "add",
							path: "/dashboard/models/new"
						}
					]}
				/>
			</>
		);
	}
}
